import React, { useState, useEffect } from "react";
import { useWatchState, setState, handler, useModal, useDebounce } from "@/store";
import { checkResult, createSelectOption } from "@/common";
import { Upload, ImgContainer } from "@/components";
import BraftEditor from "braft-editor";
import { BaseService, uploadUrl, TYCService } from "@/service";
import { orgType, economicCircle, companyScale, teamScale, intellectualProperty, ownership, resultProcess, cooperation, resultTerm, resultExtensionMode } from "@/dic";
import moment from "moment";
import { Modal, Button, Form, Input, message, Menu, Select, Cascader, Radio, Tag, Icon, Dropdown, Row, Col, Divider, InputNumber } from "antd";

const { TextArea } = Input;
const TABLE_NAME = "thtt_chengguo";
const NAME = "result";

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};

const App = Form.create({ name: 'register' })(({ form }) => {

    const { getFieldDecorator } = form;

    const [loading, setLoading] = useState(false);

    const [scopeSelectModal] = useModal(["scopeSelect"])
    const [[{ user_id }]] = useWatchState(["user.info"])
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME])
    const { title = "发布成果", show, hide, width = 800, vo = { sub_type: 1 }, state, contrast, callback, scopes = [], files = {}, UPLOAD_SERVER_HOST } = modalProps;
    const [[REGIONS = []]] = useWatchState(["$_REGIONS"]);

    const [searchResult, setSearchResult] = useState([]);
    const [showSearchRes, setShowSearchRes] = useState(false);
    const [selectOrgVo, setSelectOrg] = useState();

    useEffect(() => {
        if (!show) {
            setSelectOrg();
        }
    }, [show])

    const onCloseScope = (index, e) => {
        // 组织 antd 默认事件，它会自动把当前点击标签后面的标签隐藏掉！还不知道为什么
        e.preventDefault();
        scopes.remove(index);
        setProps({ ...modalProps })
    }

    const onChangeOrgScope = scopes => {
        modalProps.scopes = scopes;
        setProps({ ...modalProps })
    }

    const orgHandle = async (vo) => {
        const add_time = parseInt(new Date().getTime() / 1000)

        let unit_id = "";
        let org = {};
        if (vo.org_type !== undefined) org.type = vo.org_type;
        if (vo.org_name) org.name = vo.org_name;
        if (vo.org_profile) org.profile = vo.org_profile.toHTML ? vo.org_profile.toHTML() : vo.org_old_profile;
        if (vo.org_reg_location) org.reg_location = vo.org_reg_location;
        if (vo.org_team_scale) org.team_scale = vo.org_team_scale;
        if (vo.org_contacts) org.contacts = vo.org_contacts;
        if (vo.org_contacts_tel) org.contacts_tel = vo.org_contacts_tel;
        if (vo.org_contacts_email) org.contacts_email = vo.org_contacts_email;
        if (vo.org_wechat) org.wechat = vo.org_wechat;
        if (vo.org_economic_circle) org.economic_circle = vo.org_economic_circle;
        if (vo.org_staff_num_range) org.staff_num_range = vo.org_staff_num_range;
        if (vo.org_talent) org.talent = vo.org_talent;
        if (vo.org_equipment) org.equipment = vo.org_equipment;
        if (vo.org_business_direction) org.business_direction = vo.org_business_direction;
        if (vo.org_performance) org.performance = vo.org_performance;
        if (vo.org_provinceName) org.provinceName = vo.org_provinceName;
        if (vo.org_cityName) org.cityName = vo.org_cityName;
        if (vo.org_countyName) org.countyName = vo.org_countyName;
        if (vo.org_province) org.province = vo.org_province;
        if (vo.org_city) org.city = vo.org_city;
        if (vo.org_county) org.county = vo.org_county;

        // 保存机构信息
        if (selectOrgVo && selectOrgVo.name === vo.org_name) {
            org.estiblish_time = selectOrgVo.estiblishTime;
            org.legal_person_name = selectOrgVo.legalPersonName;
            org.tyc_org_id = selectOrgVo.id;
            org.tyc_type = selectOrgVo.companyType;
            org.social_credit_code = selectOrgVo.creditCode;
            org.organization_code = selectOrgVo.orgNumber;
            org.reg_number = selectOrgVo.regNumber;
            org.legal_type = selectOrgVo.type;
        }
        // 先查询是否已经存在
        let list = [];
        if (vo.org_name) {
            const getRes = await BaseService.list({
                table: "thtt_organization",
                where: {
                    name: vo.org_name,
                    is_delete: 0
                }
            })
            list = getRes.data.result;
        }

        // 修改
        if (list.length) {
            const organization_id = list[0].organization_id;
            unit_id = organization_id;
            await BaseService.put({
                table: "thtt_organization",
                data: org,
                where: { organization_id }
            })
        } else { // 新增
            if (!org.name) return;
            const addRes = await BaseService.add({
                table: "thtt_organization",
                data: { ...org, is_delete: 0, add_time, audit_status: 4 },
                key: "organization_id"
            })
            if (!checkResult(addRes)) return setLoading(false);
            unit_id = addRes.data.result.organization_id;
        }

        return unit_id
    }

    const add = async vo => {
        const add_time = parseInt(new Date().getTime() / 1000)
        setLoading(true);

        const unit_id = await orgHandle(vo);

        try {

            const res = await BaseService.add({ table: TABLE_NAME, data: { ...vo, add_time, unit: unit_id, is_delete: 0, add_user: user_id, audit_status: 1, complete_time: new Date().format("yyyy-MM-dd hh:mm:ss") }, key: "chengguo_id" });
            if (!checkResult(res)) return setLoading(false);
            const chengguo_id = res.data.result.chengguo_id;
            // 保存成果领域
            const scopeRes = await BaseService.adds({
                table: "thtt_chengguo_scope",
                data: scopes.map(({ value, pid }) => ({ chengguo_id, first_scope_id: pid, second_scope_id: value }))
            })
            let _files = []
            Object.values(files).forEach(arr => _files = _files.concat(arr));
            const addFileRes = await BaseService.adds({
                table: "thtt_attachment_relation",
                data: _files.map(val => ({ ...val, item_id: chengguo_id }))
            })
            setLoading(false);
            if (!checkResult(scopeRes)) return;
            message.success("添加成功！");
            hide();
            if (callback) callback();
        } catch (error) {
            setLoading(false);
        }
    }

    const put = async values => {
        const update_time = moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        console.log(values)
        let vo = contrast(values, ["chengguo_id", "org_name"]);
        console.log(vo)
        setLoading(true);
        try {
            const unit_id = await orgHandle(vo);

            const res = await BaseService.put({ table: TABLE_NAME, data: { ...vo, update_time, unit: unit_id }, where: { chengguo_id: vo.chengguo_id } });
            if (!checkResult(res)) return setLoading(false);

            const works = [
                {
                    controller: "remove",
                    params: {
                        table: "thtt_chengguo_scope",
                        where: {
                            chengguo_id: vo.chengguo_id
                        }
                    }
                },
                {
                    controller: "adds",
                    params: {
                        table: "thtt_chengguo_scope",
                        data: scopes.map(({ value, pid }) => ({ chengguo_id: vo.chengguo_id, first_scope_id: pid, second_scope_id: value }))
                    }
                }
            ]
            const scopeRes = await BaseService.work(works)
            let _files = []
            Object.values(files).forEach(arr => _files = _files.concat(arr));
            const works2 = [
                {
                    controller: "remove",
                    params: {
                        table: "thtt_attachment_relation",
                        where: {
                            item_id: vo.chengguo_id,
                            type: Object.keys(files)
                        }
                    }
                },
                {
                    controller: "adds",
                    params: {
                        table: "thtt_attachment_relation",
                        data: _files
                    }
                }
            ]
            const fileRes = await BaseService.work(works2)

            setLoading(false);
            message.success("修改成功！");
            hide();
            if (callback) callback();
        } catch (error) {
            setLoading(false);
            throw error
        }
    }

    const funs = { add, put }

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                const data = { ...vo, ...values };

                if (!scopes.length) return message.warn("请选择领域！")
                if (!data.profile) return message.warn("请输入成果简介！")

                if (!data.org_province && !data.region_id) return message.warn("请选择所属地区！")

                if (data.profile) data.profile = data.profile.toHTML ? data.profile.toHTML() : data.old_profile;
                funs[state](data);
            }
        });
    };

    const onUploadFinish = (e) => {
        const url = e.file.response.files[0].url;
        vo.cover = url;
        setState("modal." + NAME + ".vo", { ...vo });
    }

    const onUploadFileFinish = (type, e) => {
        const size = e.file.size;
        const add_time = new Date().format("yyyy-MM-dd hh:mm:ss");
        const newFiles = e.file.response.files.map(({ fileShowName, suffix, url }) => ({ type, item_id: vo.chengguo_id, file_name: fileShowName, file_path: url, file_suffix: suffix, size, add_time }));
        if (!modalProps.files) modalProps.files = {};
        if (!modalProps.files[type]) modalProps.files[type] = newFiles;
        else modalProps.files[type] = modalProps.files[type].concat(newFiles);
        setProps({ ...modalProps });
    }
    const onRemoveFile = (type, file) => {
        modalProps.files[type].remove(file.uid - 1);
        setProps({ ...modalProps });
    }

    // 选中搜索结果
    const selectOrg = org => {
        const { name } = org;
        setSelectOrg(org)
        form.setFieldsValue({
            org_name: name,
        });
        getAndRefreshOrg(name)
    }

    const getAndRefreshOrg = name => {
        BaseService.list({
            table: "thtt_organization",
            columns: ["type", "profile", "reg_location", "contacts", "contacts_tel", "contacts_email", "wechat", "economic_circle", "staff_num_range", "talent", "equipment", "business_direction", "performance", "team_scale", "province", "city", "county", "provinceName", "cityName", "countyName"].map(field => `${field} AS org_${field}`).join(","),
            where: { name, is_delete: 0 }
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result;
            if (data.length) {
                const org = data[0];
                org.org_profile = BraftEditor.createEditorState(org.org_profile);
                modalProps.vo.org_region_id = [vo.org_province, vo.org_city, vo.org_county];
                modalProps.vo.org_profile = org.org_profile;
                modalProps.vo = {
                    ...modalProps.vo,
                    ...org
                }
                setProps({ ...modalProps });
                form.setFieldsValue(org);
            }
        })
    }

    const getMenu = (data = []) => {
        return (
            <Menu className="search_result_list" style={{ height: "200px", overflow: "auto" }}>
                {data.map(org => (
                    <Menu.Item onClick={selectOrg.later({ ...org, name: org.name.getBytesContent() })}><div dangerouslySetInnerHTML={{ __html: org.name }} /></Menu.Item>
                ))}
            </Menu>
        )
    }

    const onChnageOrgName = useDebounce(word => {
        TYCService.search({ word }).then(res => {
            if (!checkResult(res)) return;
            setSearchResult(res.data.result.records || res.data.result.items)
        }, err => {
            throw err;
        })
    }, 200)

    const onChangeOrgProfile = e => {
        if (!modalProps.vo) modalProps.vo = { sub_type: 1 }
        modalProps.vo.org_profile = e;
        setProps({ ...modalProps });
    }

    const onChangeProfile = e => {
        if (!modalProps.vo) modalProps.vo = { sub_type: 1 }
        modalProps.vo.profile = e;
        setProps({ ...modalProps });
    }

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
            destroyOnClose={true}
        >
            <Form onSubmit={handleSubmit}>
                <div className="over-auto" style={{ height: "65vh" }}>
                    <Divider orientation="left">基本信息</Divider>
                    <Form.Item label="单位/个人">
                        {getFieldDecorator('sub_type', {
                            initialValue: vo.sub_type,
                            rules: [
                                {
                                    required: true,
                                },
                            ],
                        })(<Radio.Group onChange={e => setState("modal." + NAME + ".vo.sub_type", e.target.value)}>
                            <Radio value={1}>单位</Radio>
                            <Radio value={2}>个人</Radio>
                        </Radio.Group>)}
                    </Form.Item>
                    <Row gutter={18}>

                        {vo.sub_type === 1 && (
                            <Col span={12}>
                                <Form.Item label="单位名称">
                                    <Dropdown overlay={getMenu(searchResult)} visible={searchResult.length && showSearchRes}>
                                        {getFieldDecorator('org_name', {
                                            initialValue: vo.org_name,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入单位名称！',
                                                },
                                            ],
                                        })(
                                            <Input onChange={e => {
                                                const word = e.target.value;
                                                if (!word) {
                                                    setSearchResult([]);
                                                    return
                                                }
                                                if (word) onChnageOrgName(word)
                                            }} maxLength={100} onFocus={setShowSearchRes.later(true)} onBlur={() => setTimeout(() => setShowSearchRes(false), 100)} placeholder="请输入单位名称" autoComplete="off" />
                                        )}
                                    </Dropdown>
                                </Form.Item>
                            </Col>
                        )}
                        {vo.sub_type === 2 && (
                            <Col span={12}>
                                <Form.Item label="成果负责人">
                                    {getFieldDecorator('director', {
                                        initialValue: vo.director,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入成果负责人！',
                                            },
                                        ],
                                    })(<Input maxLength={20} placeholder="请输入成果负责人" />)}
                                </Form.Item>
                            </Col>
                        )}
                        {vo.sub_type === 2 && (
                            <Col span={12}>
                                <Form.Item label="身份证号">
                                    {getFieldDecorator('id_number', {
                                        initialValue: vo.id_number,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入身份证号！',
                                            },
                                        ],
                                    })(<Input maxLength={100} placeholder="请输入身份证号" />)}
                                </Form.Item>
                            </Col>
                        )}
                        {vo.sub_type === 1 && (
                            <Col span={12}>
                                <Form.Item label="单位属性">
                                    {getFieldDecorator('org_type', {
                                        initialValue: vo.org_type,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择单位属性！',
                                            },
                                        ],
                                    })(<Select placeholder="请选择单位属性">{createSelectOption(orgType)}</Select>)}
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                    {vo.sub_type === 1 && (
                        <Form.Item label="单位简介">
                            <BraftEditor className="border bor-ra-xs" value={vo.org_profile} onChange={onChangeOrgProfile} placeholder={'请输入简介！'} />
                        </Form.Item>
                    )}
                    <Form.Item label="所属地区" required>
                        {getFieldDecorator(vo.sub_type === 1 ? 'org_region_id' : "region_ids", {
                            getValueFromEvent: vo.sub_type === 1 ? (v, o) => {
                                const values = o.map(({ value }) => value)
                                const names = o.map(({ label }) => label)

                                vo.org_province = values[0];
                                vo.org_city = values[1];
                                vo.org_county = values[2];

                                vo.org_provinceName = names[0];
                                vo.org_cityName = names[1];
                                vo.org_countyName = names[2];
                                setState("modal." + NAME + ".vo", { ...vo });
                                return v;
                            } : (key, v) => {
                                vo.region_id = v.map(({ value }) => value).join(",");
                                vo.region_name = v.map(({ label }) => label).join(",");
                                setState("modal." + NAME + ".vo", { ...vo });
                                return key;
                            }
                        })(
                            <Cascader
                                options={REGIONS}
                                changeOnSelect
                                loadData={handler.onLoadRegion}
                                className={(vo.region_name || vo.org_provinceName) && "mockInput"}
                                placeholder={vo.sub_type === 2
                                    ? (vo.region_name ? vo.region_name.split(",").join(" / ") : '请选择地区！')
                                    : vo.org_provinceName ? [vo.org_provinceName, vo.org_cityName, vo.org_countyName].join(" / ") : '请选择地区！'} />
                        )}
                    </Form.Item>
                    <Form.Item label="通讯地址">
                        {getFieldDecorator("contacts_addr", {
                            initialValue: vo.contacts_addr,
                            rules: [
                                {
                                    required: true,
                                    message: '请输入通讯地址！',
                                },
                            ],
                        })(<Input maxLength={500} placeholder="请输入通讯地址" />)}
                    </Form.Item>
                    <Row gutter={18}>
                        <Col span={12}>
                            <Form.Item label="联系人">
                                {getFieldDecorator("contacts", {
                                    initialValue: vo.contacts,
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入联系人！',
                                        },
                                    ],
                                })(<Input maxLength={50} placeholder="请输入联系人" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="联系电话">
                                {getFieldDecorator("contacts_tel", {
                                    initialValue: vo.contacts_tel,
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入联系电话！',
                                        },
                                    ],
                                })(<Input maxLength={100} placeholder="请输入联系电话" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="E-mail">
                                {getFieldDecorator("contacts_email", {
                                    initialValue: vo.contacts_email,
                                })(<Input maxLength={200} placeholder="请输入E-mail" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="微信">
                                {getFieldDecorator("contacts_wechat", {
                                    initialValue: vo.contacts_wechat,
                                })(<Input maxLength={100} placeholder="请输入微信" />)}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={18}>
                        {vo.sub_type === 1 && (
                            <Col span={12}>
                                <Form.Item label="经济圈划定">
                                    {getFieldDecorator('org_economic_circle', {
                                        initialValue: vo.org_economic_circle,
                                    })(<Select placeholder="请选择经济圈划定">{createSelectOption(economicCircle)}</Select>)}
                                </Form.Item>
                            </Col>
                        )}
                        {vo.sub_type === 1 && (
                            <Col span={12}>
                                <Form.Item label="单位规模">
                                    {getFieldDecorator('org_staff_num_range', {
                                        initialValue: vo.org_staff_num_range,
                                    })(<Select placeholder="请选择单位规模">{createSelectOption(companyScale)}</Select>)}
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                    {vo.sub_type === 1 && (
                        <Form.Item label="人才">
                            {getFieldDecorator('org_talent', {
                                initialValue: vo.org_talent,
                            })(<TextArea maxLength={500} rows={10} placeholder="项目领军人物水平" />)}
                        </Form.Item>
                    )}
                    {vo.sub_type === 1 && (
                        <Form.Item label="团队规模">
                            {getFieldDecorator('org_team_scale', {
                                initialValue: vo.org_team_scale,
                            })(<Select placeholder="请选择团队规模">{createSelectOption(teamScale)}</Select>)}
                        </Form.Item>
                    )}
                    {vo.sub_type === 1 && (
                        <Form.Item label="装备">
                            {getFieldDecorator('org_equipment', {
                                initialValue: vo.org_equipment,
                            })(<TextArea maxLength={500} rows={10} placeholder="实验室级别，地位，规模" />)}
                        </Form.Item>
                    )}
                    {vo.sub_type === 1 && (
                        <Form.Item label="业务">
                            {getFieldDecorator('org_business_direction', {
                                initialValue: vo.org_business_direction,
                            })(<TextArea maxLength={500} rows={10} placeholder="主攻研究方向" />)}
                        </Form.Item>
                    )}
                    {vo.sub_type === 1 && (
                        <Form.Item label="业绩">
                            {getFieldDecorator('org_performance', {
                                initialValue: vo.org_performance,
                            })(<TextArea maxLength={500} rows={10} placeholder="专利，论文，奖项" />)}
                        </Form.Item>
                    )}

                    <Divider orientation="left">成果信息</Divider>

                    <Form.Item label="成果名称">
                        {getFieldDecorator('name', {
                            initialValue: vo.name,
                            rules: [
                                {
                                    required: true,
                                    message: '请输入成果名称！',
                                },
                            ],
                        })(<Input maxLength={200} placeholder="请输入成果名称" />)}
                    </Form.Item>
                    <Form.Item label="封面" required>
                        {getFieldDecorator('cover', {
                            initialValue: vo["cover"],
                        })(
                            <Upload
                                style={{ minWidth: "160px" }}
                                accept=".jpg,.jpeg,.png"
                                name="files"
                                listType="picture-card"
                                showUploadList={false}
                                onFinish={onUploadFinish}
                                action={uploadUrl}
                            >
                                {vo["cover"]
                                    ? <ImgContainer
                                        src={"http://" + UPLOAD_SERVER_HOST + vo["cover"]}
                                        width={150}
                                        scale={9 / 16} />
                                    : "上传封面"}
                            </Upload>
                        )}
                    </Form.Item>
                    <Form.Item label="领域" required>
                        <div className="p-sm-l">
                            {scopes.map(({ label }, i) => <Tag className="white-tag" key={label} closable onClose={onCloseScope.later(i)}>{label}</Tag>)}
                            <Button className="ant-tag--addBtn" onClick={scopeSelectModal.show.later({ selectScope: scopes, callback: onChangeOrgScope })} type="primary" >+</Button>
                        </div>
                    </Form.Item>
                    <Row gutter={18}>
                        <Col span={12}>
                            <Form.Item label="知识产权状况">
                                {getFieldDecorator('intellectual_property', {
                                    initialValue: vo.intellectual_property,
                                })(<Select placeholder="请选择知识产权状况">{createSelectOption(intellectualProperty)}</Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="知识产权证书号">
                                {getFieldDecorator('intellectual_property_code', {
                                    initialValue: vo.intellectual_property_code,
                                })(<Input maxLength={255} placeholder="请输入知识产权证书号" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="成果权属">
                                {getFieldDecorator('ownership', {
                                    initialValue: vo.ownership,
                                })(<Select placeholder="请选择成果权属">{createSelectOption(ownership)}</Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="成果阶段">
                                {getFieldDecorator('process', {
                                    initialValue: vo.process,
                                })(<Select placeholder="请选择成果阶段">{createSelectOption(resultProcess)}</Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="合作方式">
                                {getFieldDecorator('cooperation', {
                                    initialValue: vo.cooperation || undefined,
                                })(<Select placeholder="请选择合作方式" mode="multiple">{createSelectOption(cooperation)}</Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="需合作方投入资金">
                                {getFieldDecorator('investment', {
                                    initialValue: vo.investment,
                                })(<InputNumber maxLength={11} placeholder="请输入需合作方投入资金" addonAfter="万元" />)}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="资金用途">
                        {getFieldDecorator('investment_use', {
                            initialValue: vo.investment_use,
                        })(<TextArea maxLength={500} rows={10} placeholder="请输入资金用途" />)}
                    </Form.Item>
                    <Form.Item label="成果简介" required>
                        <BraftEditor className="border bor-ra-xs" value={vo.profile} onChange={onChangeProfile} placeholder={'成果的简要介绍，包含成果来源，成果和成果进展。（至少200个字符，100个汉字）'} />
                    </Form.Item>
                    <Form.Item label="实施条件">
                        {getFieldDecorator('implementation_conditions', {
                            initialValue: vo.implementation_conditions,
                        })(<TextArea maxLength={500} rows={10} placeholder="请输入实施条件" />)}
                    </Form.Item>
                    <Form.Item label="发布有效期">
                        {getFieldDecorator('term', {
                            initialValue: vo.term,
                        })(<Select placeholder="请选择发布有效期">{createSelectOption(resultTerm)}</Select>)}
                    </Form.Item>
                    <Form.Item label="发布范围">
                        {getFieldDecorator('ranges', {
                            initialValue: vo.ranges,
                        })(<TextArea maxLength={500} rows={10} placeholder="请输入发布范围" />)}
                    </Form.Item>
                    <Form.Item label="保密要求">
                        {getFieldDecorator('secrecy', {
                            initialValue: vo.secrecy,
                        })(<TextArea maxLength={500} rows={10} placeholder="请输入保密要求" />)}
                    </Form.Item>
                    <Form.Item label="天合成果推广模式">
                        {getFieldDecorator('extension_mode', {
                            initialValue: vo.extension_mode,
                        })(<Select placeholder="请选择发布有效期">{createSelectOption(resultExtensionMode)}</Select>)}
                    </Form.Item>
                    <Row gutter={18}>
                        <Col span={12}>
                            <Form.Item label="发布文档">
                                {getFieldDecorator('build_docs', {
                                    initialValue: vo["build_docs"],
                                })(
                                    <Upload
                                        style={{ minWidth: "160px" }}
                                        name="files"
                                        onFinish={onUploadFileFinish.later("build_docs")}
                                        action={uploadUrl}
                                        defaultFileList={(files.build_docs || []).map(({ file_name, file_path }, i) => ({ name: file_name, url: `http://${UPLOAD_SERVER_HOST}${file_path}`, status: 'done', uid: i + 1 }))}
                                        onRemove={onRemoveFile.later("build_docs")}
                                    >
                                        <Button><Icon type="upload" /> 上传</Button>
                                    </Upload>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="背景材料、信息袋">
                                {getFieldDecorator('enclosure', {
                                    initialValue: vo["enclosure"],
                                })(
                                    <Upload
                                        style={{ minWidth: "160px" }}
                                        name="files"
                                        onFinish={onUploadFileFinish.later("enclosure")}
                                        action={uploadUrl}
                                        defaultFileList={(files.enclosure || []).map(({ file_name, file_path }, i) => ({ name: file_name, url: `http://${UPLOAD_SERVER_HOST}${file_path}`, status: 'done', uid: i + 1 }))}
                                        onRemove={onRemoveFile.later("enclosure")}
                                    >
                                        <Button><Icon type="upload" /> 上传</Button>
                                    </Upload>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                <Form.Item {...tailFormItemLayout} className="m-sm-t">
                    <Button type="primary" htmlType="submit" loading={loading}>
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
})

export default App;